import { TimesheetsTableFooter } from '../Cells/TimesheetsTableFooterCell';
import { DaysForecastedHours } from '../utils/getForecasteHours';
import { TableRowFooter } from '../Rows/styles/TimesheetsFooterRow.styled';
import {
  generateReactKey,
  KeyRoots,
} from 'src/utils/generateUniqueReactKey/generateUniqueReactKey';

interface TimeSheetsFooterRowProps {
  data?: string[];
  forecastedHours?: DaysForecastedHours[];
  footerTitle?: string;
}
export const MobileTimesheetsFooterRow = ({
  data,
  forecastedHours,
  footerTitle,
}: TimeSheetsFooterRowProps) => {
  return (
    <TableRowFooter>
      {footerTitle ? (
        <TimesheetsTableFooter data={footerTitle} index={0} />
      ) : (
        <>
          {data.map((cell, index) => {
            return (
              <TimesheetsTableFooter
                key={generateReactKey(
                  KeyRoots.TIME_SHEET_MOBILE_FOOTER_CELL,
                  index
                )}
                data={cell}
                dayForecastedHours={
                  index === 8
                    ? forecastedHours[index].totalWeekHours
                    : forecastedHours[index].dayOfweek
                }
                dayForcastedType={
                  index === 8
                    ? forecastedHours[index].totalWeekType
                    : forecastedHours[index].dayOfWeekType
                }
                index={index}
                isDataCell={true}
              />
            );
          })}
        </>
      )}
    </TableRowFooter>
  );
};
